module.exports = __webpack_public_path__ + "media/images/recipes/varkenshaas-a68e5233e10ed915a93eedf9d026e9fc.pdf";